export const capitalizeFirstLetter = function (inputString: string): string {
    if (inputString.length === 0)
        return ""
    const firstLetter = inputString.charAt(0).toUpperCase()
    const restOfTheString = inputString.slice(1).toLowerCase()

    return firstLetter + restOfTheString
}